import React from 'react';
import './Nav.css';
import Others from './Others';
import logo from './draftlogo333.png'; // Ensure you have a logo image in the src folder

const Nav = () => {
    return (
        <div className="Appnav">
            <NavBar />
            <div className="contentnav">
                <h2>Dive into Kid World- a joyful playground that boosts thinking skills, sparks creativity and makes learning feel like play....</h2>
            </div>
        </div>
    );
};
const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}
const NavBar = () => {
    return (
        <nav className="navbar">
            <img src={logo} alt="Logo" className="logo1" />
            {/* <h1 className="titlenav">My App</h1> */}
            {/* <button className='home-buttonnav' onClick={<Others/>}>Games & Others</button> */}
            <button className="home-buttonnav" onClick={openUrl}>Home</button>
            
        </nav>
    );
};

export default Nav;
